import type { PersonLocationType } from './person-location-assignment.model';

export interface LocationAssignmentLike {
  type: PersonLocationType;
  startDate?: string | null;
  endDate?: string | null;
  rrule?: string | null;
}

export interface LocationAssignmentPatch {
  type?: PersonLocationType;
  startDate?: string | null;
  endDate?: string | null;
  rrule?: string | null;
}

export interface LocationCreatePayload {
  locationId: string;
  type: PersonLocationType;
  startDate?: string;
  endDate?: string;
  rrule?: string | null;
}

export function diffLocationAssignment(o: LocationAssignmentLike, a: LocationAssignmentLike): LocationAssignmentPatch {
  const patch: LocationAssignmentPatch = {};
  if (o.type !== a.type) patch.type = a.type;
  if ((o.startDate ?? null) !== (a.startDate ?? null)) patch.startDate = a.startDate ?? null;
  if ((o.endDate ?? null) !== (a.endDate ?? null)) patch.endDate = a.endDate ?? null;
  if ((o.rrule ?? null) !== (a.rrule ?? null)) patch.rrule = a.rrule ?? null;
  return patch;
}

export function locationCreatePayload(locationId: string, a: LocationAssignmentLike): LocationCreatePayload {
  const payload: LocationCreatePayload = { locationId, type: a.type };
  if (a.startDate) payload.startDate = a.startDate;
  if (a.endDate) payload.endDate = a.endDate;
  if (a.rrule) payload.rrule = a.rrule;
  return payload;
}
